import { render, staticRenderFns } from "./details-reisefinder.vue?vue&type=template&id=8ad6205c&scoped=true"
import script from "./details-reisefinder.vue?vue&type=script&lang=js"
export * from "./details-reisefinder.vue?vue&type=script&lang=js"
import style0 from "./details-reisefinder.vue?vue&type=style&index=0&id=8ad6205c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad6205c",
  null
  
)

export default component.exports